const HouseSBABIcon = ({ className }: { className: string }) => {
  return (
    <svg
      aria-hidden='true'
      width='71'
      height='70'
      viewBox='0 0 71 70'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M33.0371 10.5907L32.1214 9.5187L8.42969 29.7772L14.4595 36.8403L17.5899 34.1636L17.333 64.226L53.1143 64.5312L53.3796 33.45L56.3237 36.3537L62.7671 29.8078L38.0791 5.46875L33.0371 10.5907Z'
        fill='currentColor'
      />
    </svg>
  );
};

export default HouseSBABIcon;
